import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Het nut van een rustdag</title>
                <link rel="canonical" href={route("blogs.eleventh")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Rustdagen; voor de één een geschenk uit de hemel, voor de ander iets wat ze liever niet doen. Je hoort weleens mensen zeggen dat rustdagen niet nodig zijn. Hoe vaker je traint, hoe beter toch?"
                />
                <meta
                    property="og:description"
                    content="Rustdagen; voor de één een geschenk uit de hemel, voor de ander iets wat ze liever niet doen. Je hoort weleens mensen zeggen dat rustdagen niet nodig zijn. Hoe vaker je traint, hoe beter toch?"
                />
                <meta property="og:url" content={route("blogs.eleventh")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Het nut van een rustdag - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/nut-rustdag.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh]  pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/nut-rustdag.webp"
                                    type="image/webp"
                                    alt="Rustdag"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/nut-rustdag.jpg"
                                    type="image/jpeg"
                                    alt="Rustdag"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/nut-rustdag.jpg"
                                    alt="Rustdag"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Hebben we een rustdag nodig?
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Rustdagen; voor de één een geschenk uit de hemel, voor
                        de ander iets wat ze liever niet doen. Je hoort weleens
                        mensen zeggen dat rustdagen niet nodig zijn. Hoe vaker
                        je traint, hoe beter toch?
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Dit is niet helemaal waar. Hoe vaker je traint, hoe meer
                        calorieën je verbrandt tijdens het trainen. Dat klopt.
                        In de tussentijd maak je echter meer kapot dan je op het
                        begin zult merken omdat je lichaam onvoldoende tijd
                        krijgt om te herstellen.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Het nut van een rustdag
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Tijdens een intensieve workout komen er minuscule
                        scheurtjes in de spieren. Je lichaam word aan het werk
                        gezet om deze minuscule scheurtjes te herstellen. Dit
                        zal zodanig gebeuren dat je sterker zult worden en
                        meer/makkelijker gewicht aankunt.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Als je te weinig rust neemt krijgt je lichaam niet
                        voldoende tijd om de minuscule scheurtjes in je spieren
                        te herstellen. Hierdoor word je dus niet sterker of in
                        sommige gevallen juist minder sterk dat dan je was. In
                        onderstaand plaatje zie je een fenomeen genaamd
                        supercompensatie.
                    </p>
                    <img
                        className="w-50 h-50 object-cover my-4"
                        src="/assets/blog/supercompensatie.jpeg"
                        alt="Supercompensatie sporten"
                    />
                    <p className="mt-4 text-gray-100 break-words">
                        Je ziet dat in het eerste gedeelte je spieren beschadigd
                        raken en daarmee zwakker worden. Daarna komt het
                        herstel, waarin de spieren weer langzaam sterker zullen
                        worden. Ze worden zelfs sterker dan ze van tevoren
                        waren, zoals je ziet aan de rode lijn die boven de
                        zwarte lijn uitkomt. Het gebied wat boven de zwarte lijn
                        zit noemen we dus supercompensatie. In deze fase ben je
                        sterker dan dat je voor de training was.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Aan dit plaatje kun je ook afleiden wat er gebeurd als
                        je onvoldoende rust neemt. Als je te weinig tijd hebt
                        voor herstel loopt de rode lijn nog onder de zwarte
                        lijn. Dit betekent dus dat je spieren minder sterk zijn
                        op dat moment dan bij de training die je vorige keer
                        deed.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
